import store from './store';
import { authData } from '../lib/login';
let initAuth = authData() || { member: null, positions: null, time: null, expires: null };;

window.authData = authData;
let initialState = {
  logged_in: initAuth && initAuth.time && initAuth.time + 3600000 > Date.now(),
  login_error: null,
  ...initAuth,
};

export const SET_LOGIN_STATE = 'SET_LOGIN_STATE';
export const REQUEST_LOGIN = 'REQUEST_LOGIN';
export const UPDATE_LOGIN = 'UPDATE_LOGIN';

export const logout = () => {
  store.dispatch(execLogout());
};

export const getLoginState = state => {
  return state.auth.logged_in;
};

export const getLoginEmail = state => {
  if (!state.auth.member) {
    return '';
  }
  if (!state.auth.member.individual) {
    return '';
  }
  if (!state.auth.member.individual.email) {
    return '';
  }
  return state.auth.member.individual.email;
};

export const getLoginPositions = state => {
  if (!state.auth.positions) {
    return new Set();
  }
  return new Set(state.auth.positions);
};

export const getLoginTime = state => {
  if (!state.auth.time) {
    return 0;
  }
  return state.auth.time;
};

export const getLoginError = state => {
  return state.auth.login_error;
};

export const updateLogin = () => {
  return { type: UPDATE_LOGIN, cookie: document.cookie };
};

export const requestLogin = message => {
  return { type: REQUEST_LOGIN, message: message };
};

export const execLogin = (email, password) => {
  return dispatch => {
    const form = new FormData();
    form.append('email', email);
    form.append('password', password);
    return fetch('/api/login', {
      method: 'POST',
      body: form,
      credentials: 'same-origin',
    })
      .then(resp => {
        if (resp.status === 200) {
          return resp.json();
        }
        if (resp.status === 401) {
          return resp.json()
            .catch(err => { throw new Error("Login Failed") })
            .then(obj => { throw new Error(obj.message) });
        }
        if (resp.status === 403) {
          return resp.json()
            .catch(err => { throw new Error("Forbidden") })
            .then(obj => { throw new Error(obj.message) });
        }
        resp.text().then(text => {
          throw new Error("HTTP " + resp.status + " / " + resp.statusText + "\n" + text);
        });
      })
      .then(info => {
        return dispatch(checkLogin());
      })
      .catch(err => {
        return dispatch({
          type: SET_LOGIN_STATE,
          positions: null,
          logged_in: false,
          login_error: err.message,
        });
      });
  };
};

export const checkLogin = () => {
  const info = authData();
  const action = {
    type: SET_LOGIN_STATE,
  };
  if (info === null || info.member === null) {
    action.logged_in = false;
    action.positions = null;
    action.time = null;
    action.expires = null;
  } else {
    action.member = info.member;
    action.positions = info.positions;
    action.time = info.time;
    action.expires = info.expires;
    action.logged_in = true;
    action.login_error = null;
  }
  return action;
};

export const execLogout = () => {
  return dispatch => {
    document.cookie = 'auth=';
    return dispatch(checkLogin());
  };
};

const doRequestLogin = (state, action) => {
  return Object.assign({}, state, { logged_in: false, login_error: action.message });
};

const doSetLoginState = (state, action) => {
  const { type, ...info } = action;
  return Object.assign({}, state, info);
};

const doUpdateLogin = (state, action) => {
  const { cookie } = action;
  const auth = authData(cookie);
  return Object.assign({}, state, {
    email: auth.email,
    auth_time: auth.time,
    positions: auth.positions,
  });
};

/*
const doLogout = (state, action) => {
  document.cookie = 'auth=';
  return Object.assign({}, state, {
    auth_time: null,
    positions: [],
    logged_in: false,
  });
};
*/

export default (state = initialState, action) => {
  switch (action.type) {
  case REQUEST_LOGIN:
    return doRequestLogin(state, action);
  case SET_LOGIN_STATE:
    return doSetLoginState(state, action);
  case UPDATE_LOGIN:
    return doUpdateLogin(state, action);
  default:
    return state;
  }
};

